export interface WorkflowDialogConfig {
    opType: string;
    data: any;
    disabledCancel?: boolean;
}

export enum WorkflowDialogOperations {
    NEW = 'NEW',
    COPY = 'COPY',
    EDIT = 'EDIT',
    DRAFT = 'DRAFT'
}

export const DefaultGatewayInfo = {
    'parallel': [{
        'name': 'Parallel gateway',
        'type': 'parallel'
    }, {
        'name': 'And gateway',
        'type': 'and'
    }], 'conditional': [{
        'name': 'Conditional gateway',
        'type': 'conditional'
    }, {
        'name': 'Skip gateway',
        'type': 'skip'
    }]
};
